import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Snackbar from './Snackbar';

const RegisterKit = ({ show, handleClose }) => {
  const [kitId, setKitId] = useState("");
  const [petName, setPetName] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "info" });
  const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));

  const handleNext = () => {
    if (isSubmitting) return;
    // Validate if both Kit ID and pet name are filled
    if (!kitId || !petName) {
      setError("Both Kit ID and pet name are required.");
      setSnackbar({ open: true, message: "Both Kit ID and pet name are required.", type: "error" });
      return;
    }
  
    // Store Kit ID and pet name as a single object in local storage
    const kitInfo = {
      kitId: kitId,
      petName: petName
    };
    localStorage.setItem("kitInfo", JSON.stringify(kitInfo));
  
    setIsSubmitting(true);
    setSnackbar({ open: true, message: "Kit registered successfully!", type: "success" });
    // Proceed with next action (e.g., closing the modal)
    setTimeout(() => handleClose(), 1000);
  };

  return (
    <>
      <Snackbar
        message={snackbar.message}
        type={snackbar.type}
        open={snackbar.open}
        onClose={closeSnackbar}
      />
      <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title className="modal-title">Kit Info</Modal.Title>
        <hr />
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Kit ID</Form.Label>
            <br />
            <Form.Control
              style={{ width: "100%", maxWidth: "520px", height: "25px" }}
              value={kitId}
              onChange={(e) => setKitId(e.target.value)}
            />
          </Form.Group>
          <br />
          <Form.Group className="mb-3">
            <Form.Label>Pet Name</Form.Label>
            <br />
            <Form.Control
              placeholder="Bertie"
              style={{ width: "100%", maxWidth: "520px", height: "25px" }}
              value={petName}
              onChange={(e) => setPetName(e.target.value)}
            />
          </Form.Group>
        </Form>
        {error && <p className="error-message">{error}</p>}
        <ul className="popup-text">
          <li>Enter Registration Code found on the Microbiome Analyss kit inner card and pet name.</li>
          <li>Click Next and complete survey</li>
          <li>All survey questions about your pet <b>MUST</b> be answered to complete registration</li>
          <li>When all questions are complete, click Submit button at the bottom at the bottom of the page. You will receive a Registration confirmation</li>
        </ul>
        <hr />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} className="back-modal">
          Back
        </Button>
        <Button variant="primary" onClick={handleNext} className="next-modal1">
          Next
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
}

export default RegisterKit;
